<script lang="ts">
  import { searchAIFlag, community, isAskAiTeamOnly } from "$stores/community";
  import { isTeamMember } from "$stores/permissions";
  import { getMediaQuery } from "$utils/mediaQuery";
  import { search } from "app/stores/search";
  import { track } from "app/utils/analytics";
  import { Search } from "$components/+blocks/OVIcon";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import IconButton from "$components/+blocks/IconButton/IconButton.svelte";
  import AIBadge from "$components/ai/semantic/AIBadge.svelte";

  export let message: string | undefined = undefined;

  const isDesktop = getMediaQuery("desktop");

  $: canAccessSearchAI = $searchAIFlag && (!$isAskAiTeamOnly || $isTeamMember);
</script>

{#if $isDesktop}
  <button
    class="flex h-[36px] w-[250px] items-center gap-1.5 rounded-md border-[0.5px] border-black/15 bg-black/2 px-2 py-1 text-gray-500/70 shadow-sm transition-colors hover:border-community-primary dark:border-transparent dark:bg-white/8 dark:text-gray-400 dark:shadow dark:hover:border-community-primary"
    on:click={() => {
      track("Search Button Clicked");
      $search = true;
    }}
    type="button"
  >
    <OVIcon icon={Search} size="size-3.5" />
    <span class="text-sm font-medium md:text-[13px]">
      Search{canAccessSearchAI ? " or ask..." : "..."}
    </span>
    {#if canAccessSearchAI}
      <span class="ml-auto">
        <AIBadge />
      </span>
    {/if}
  </button>
{:else}
  <IconButton
    variant="tertiary"
    icon={Search}
    size="large"
    a11yLabel={message ?? `Search ${$community.name}`}
    on:click={() => {
      track("Search Button Clicked");
      $search = true;
    }}
  />
{/if}
